import React from 'react';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	TextField,
	Box,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "pages/Chart/Chart.redux";
import indicesDialogSx from './IndiciesDialog.styles';
import { useTheme } from '@mui/material/styles';



const IndicesDialog = () => {
	const dispatch = useDispatch(),
		  theme    = useTheme(),
		  sx       = indicesDialogSx(theme),
		  values   = useSelector(state => state.chart.indices),
		  open     = useSelector(state => state.chart.toolbar.selectedTool === 'indices');

	const handleClose = () => {
		dispatch(actions.setToolbar({
			selectedButton: null,
			selectedTool: '',
		}));
	};

	const handleInput = (e) => {
		let key   = e.target.name,
			value = Number(e.target.value);

		if(isNaN(value)) {
			return false;
		}

		dispatch(actions.setState({
			indices: {
				...values,
				[ key ]: value,
			},
		}));
	};

	return (
		<Dialog open={open} onClose={handleClose} disableEscapeKeyDown>
			<DialogTitle>Indices</DialogTitle>
			<DialogContent>
				<DialogContentText>
					Set the indices for this chart below, then click Done.
				</DialogContentText>

				<Box sx={sx.inputWrapper}>
					<TextField
						label="Plaque"
						type="number"
						value={values.plaque}
						name="plaque"
						onChange={handleInput}
						variant="outlined"
					/>
				</Box>

				<Box sx={sx.inputWrapper}>
					<TextField
						label="Calculus"
						type="number"
						value={values.calculus}
						name="calculus"
						onChange={handleInput}
						variant="outlined"
					/>
				</Box>

				<Box sx={sx.inputWrapper}>
					<TextField
						label="Gingival"
						type="number"
						value={values.gingival}
						name="gingival"
						onChange={handleInput}
						variant="outlined"
					/>
				</Box>
			</DialogContent>

			<DialogActions>
				<Button color="primary" variant="contained" onClick={handleClose}>
					Done
				</Button>
			</DialogActions>
		</Dialog>
	);
};



export default IndicesDialog;
